//
//  @file EnrollMAGS.jsx
//  @author Sergii Oryshchenko <sergii.orishchenko@gmail.com>
//  @see https://github.com/os-v/
//
//  Created on 06.02.21.
//  Copyright 2021 Sergii Oryshchenko. All rights reserved.
//  Any usage of this material is strictly forbidden unless prior written permission is obtained from Sergii Oryshchenko <sergii.orishchenko@gmail.com>.
//

import React, { Component } from "react";

import EnrollBase from "views/User/EnrollBase.jsx";

import EnrollMAGSStep1 from "views/User/EnrollMAGSStep1.jsx";
import EnrollMAGSStep2 from "views/User/EnrollMAGSStep2.jsx";
import EnrollMAGSStep3 from "views/User/EnrollMAGSStep3.jsx";

import RapidaIDService from "scripts/RapidaIDService.jsx";
import RapidaIDSession from "scripts/RapidaIDSession.jsx";

import ImgTile from "assets/img/TileMAGS.png";

class EnrollMAGS extends Component
{

    constructor(props)
    {

        super(props);

        this.TokenInfo = {
            UUID: "",
            Name: "",
            Data: "",
            PIN: ""
        };

        this.TokenData = [ ];

        this.OnPrepareEdit = this.OnPrepareEdit.bind(this);
        this.OnTokenEnrolled = this.OnTokenEnrolled.bind(this);
        this.OnTokenRemoved = this.OnTokenRemoved.bind(this);

    }

    componentDidMount()
    {

        this.ReloadTokenData();

    }

    ReloadTokenData()
    {

        this.TokenData.splice(0, this.TokenData.length);

        var pData = RapidaIDSession.GetMAGSData();
        for(var iItem = 0; iItem < pData.length; iItem++)
            this.TokenData.push({ UUID: pData[iItem].UUID, Name: pData[iItem].Name });

        this.forceUpdate();

        //console.log(pData);

    }

    OnPrepareEdit(iItem, OnResult)
    {

        this.TokenInfo.UUID = iItem === -1 ? "" : this.TokenData[iItem].UUID;
        this.TokenInfo.Name = iItem === -1 ? "" : this.TokenData[iItem].Name;
        this.TokenInfo.Data = "";
        this.TokenInfo.PIN = "";
        this.TokenInfo.CPIN = "";

        var pSteps = [
            { name: global.StrName, component: <EnrollMAGSStep1 OnResult={OnResult} TokenInfo={this.TokenInfo}/> },
            { name: global.StrCard, component: <EnrollMAGSStep2 OnResult={OnResult} TokenInfo={this.TokenInfo}/> },
            { name: global.StrPIN, component: <EnrollMAGSStep3 OnResult={OnResult} TokenInfo={this.TokenInfo}/> },
        ];

        return pSteps;
    }

    OnTokenEnrolled(iItem)
    {

        console.log("EnrollMAGS::OnTokenEnrolled()");

        this.ReloadTokenData();

    }

    OnTokenRemoved(iItem)
    {
        console.log("EnrollMAGS::OnTokenRemoved(" + iItem + ")");
        RapidaIDService.UserMAGSDel(this, this.TokenData[iItem].UUID, function(pThis, eResult) {
            pThis.ReloadTokenData();
        });
    }

    render()
    {
        return (
            <EnrollBase 
                ImgTile={ImgTile} 
                EnrollTitle={global.StrEnrollNewToken} 
                BriefDesc={global.StrHereEnrollUpdateDeleteToken}
                TokenData={this.TokenData}
                TokenInfo={this.TokenInfo}
                OnPrepareEdit={this.OnPrepareEdit}
                OnTokenEnrolled={this.OnTokenEnrolled}
                OnTokenRemoved={this.OnTokenRemoved}
            />
        );
    }

}

export default EnrollMAGS;
